import Vue from 'vue'
import Router from 'vue-router'
import { AppHolder } from '@/utils/app-holder'
import AuthenticatedRoutes from './authenticated'
import AdvisoryRoutes, { AdvisoryRedirect } from './advisory'

Vue.use(Router)

let pages = {}

if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging' || process.env.NODE_ENV === 'theseis') {
  pages = require('./pages.prod').default
} else {
  pages = require('./pages.dev').default
}

const authenticatedRoutes = AuthenticatedRoutes(pages)
const advisoryRoutes = AdvisoryRoutes(pages, authenticatedRoutes)
const advisoryRedirect = AdvisoryRedirect(authenticatedRoutes)

function getElementPosition (el) {
  const docEl = document.documentElement
  const docRect = docEl.getBoundingClientRect()
  const elRect = el.getBoundingClientRect()
  return {
    x: elRect.left - docRect.left,
    y: elRect.top - docRect.top
  }
}

const router = new Router({
  mode: 'history',
  linkActiveClass: 'active-link',
  scrollBehavior: function (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    if (to.hash) {
      const el = document.querySelector(to.hash)
      if (el) {
        let pos = getElementPosition(el)
        pos.y += to.meta.offset | 0
        return pos
      }
    }
    return {x: 0, y: 0}
  },

  routes: [
    {
      path: '/',
      name: 'landing-page',
      component: pages.landingPage,
      meta: {
        authenticated: false
      }
    },
    {
      path: '/features',
      name: 'landing-features',
      component: pages.landingFeatures,
      meta: {
        authenticated: false
      }
    },
    {
      path: '/commitments',
      name: 'landing-commitments',
      component: pages.landingCommitments,
      meta: {
        authenticated: false
      }
    },
    {
      path: '/for-advisors',
      name: 'landing-pro',
      component: pages.landingPagePro,
      meta: {
        authenticated: false
      }
    },
    {
      path: '/advisor',
      name: 'landing-pro-advisor',
      component: pages.landingPageProAdvisor,
      meta: {
        authenticated: false
      }
    },
    {
      path: '/customers',
      name: 'landing-pro-customers',
      component: pages.landingPageProCustomers,
      meta: {
        authenticated: false
      }
    },
    {
      path: '/delete-profile',
      name: 'delete-profile',
      component: pages.deleteProfile
    },
    {
      path: '/app',
      name: 'authenticated',
      component: pages.authenticatedPage,
      meta: {
        authenticated: true
      },
      redirect: {
        name: 'dashboard'
      },
      children: authenticatedRoutes
    },
    {
      path: '/app',
      component: pages.lobbyContainer,
      meta: {
        authenticated: true
      },
      children: [
        {
          path: 'accounts/add',
          component: pages.accountsAdd,
          children: [
            {
              path: '',
              name: 'accounts-add-index',
              component: pages.accountsAddIndex,
              meta: {
                hideMenu: true
              }
            },
            {
              path: ':bankId',
              name: 'accounts-add-form',
              component: pages.accountsAddForm,
              props: true,
              meta: {
                hideMenu: true
              }
            },
            {
              path: 'real-estate',
              name: 'real-estate-add-form',
              component: pages.realEstateAddForm,
              props: true,
              meta: {
                hideMenu: true
              }
            },
            {
              path: 'real-estate-man',
              name: 'real-estate-add-form-man',
              component: pages.realEstateAddFormMan,
              props: true,
              meta: {
                hideMenu: true
              }
            },
            {
              path: 'evaluate',
              name: 'real-estate-evaluate',
              component: pages.realEstateEvaluateMan,
              props: true,
              meta: {
                hideMenu: true
              }
            },
            {
              path: 'evaluate-man',
              name: 'real-estate-evaluate-man',
              component: pages.realEstateEvaluate,
              props: true,
              meta: {
                hideMenu: true
              }
            }
          ]
        },
        {
          path: 'load',
          name: 'accounts-load',
          component: pages.accountsLoad,
          props: true
        },
        {
          path: 'profile',
          name: 'profile-fill',
          component: pages.profileFill,
          redirect: {name: 'profile-fill-risk'},
          children: [
            {
              path: 'risk',
              name: 'profile-fill-risk',
              component: pages.profileFillRisk
            },
            {
              path: 'infos',
              name: 'profile-fill-infos',
              component: pages.profileFillInfos,
              props: true
            },
            {
              path: 'result',
              name: 'profile-result',
              component: pages.profileResult
            }
          ]
        },
        {
          path: 'accounts/risk',
          name: 'accounts-risk',
          component: pages.accountsRisk
        },
        {
          path: 'confirmation',
          name: 'confirmation',
          component: pages.confirmationPage
        },
        {
          path: 'subscribe',
          name: 'subscribe',
          component: pages.subscriptionPage
        },
        {
          path: 'pay',
          name: 'pay',
          component: pages.paymentPage,
          props: true
        }
      ]
    },
    {
      path: '/app',
      name: 'unauthenticated',
      component: pages.lobbyContainer,
      meta: {
        authenticated: false
      },
      redirect: {
        name: 'login'
      },
      children: [
        {
          path: 'login',
          name: 'login',
          component: pages.loginPage
        },
        {
          path: 'register',
          name: 'register',
          component: pages.registerPage
        },
        {
          path: 'password-reset',
          name: 'password-reset',
          component: pages.resetPasswordPage
        }
      ]
    },
    {
      path: '/advisory',
      name: 'advisory-unauthenticated',
      component: pages.lobbyContainer,
      meta: {
        advisory: true,
        authenticated: false
      },
      redirect: {
        name: 'advisory-login'
      },
      children: [
        {
          path: 'login',
          name: 'advisory-login',
          component: pages.advisoryLoginPage
        }
      ]
    },
    advisoryRoutes,
    {
      path: '/contrats/:contractUrl',
      component: pages.contractCard
    },
    {
      path: '/cgu',
      component: pages.lobbyContainer,
      children: [
        {
          path: '',
          name: 'cgu',
          component: pages.CGUPage
        }
      ]
    },
    {
      path: '/mentions-legales',
      component: pages.lobbyContainer,
      children: [
        {
          path: '',
          name: 'legal-notice',
          component: pages.legalNoticePage
        }
      ]
    },
    {
      path: '/500',
      name: 'error500',
      component: pages.error500
    },
    {
      path: '/404',
      name: 'error404',
      component: pages.error404
    },
    {
      path: '*',
      redirect: {
        name: 'error404'
      }
    }
  ]
})

const authenticatedFilter = route => route.meta.authenticated === true
const unauthenticatedFilter = route => route.meta.authenticated === false
const advisoryFilter = route => route.meta.advisory === true
router.beforeEach((to, from, next) => {
  const { matched } = to
  const { authenticated } = AppHolder.store.state.user
  const authenticatedAdvisor = AppHolder.store.state.advisor.authenticated

  if (to.name === 'accounts-load' && from.name !== 'accounts-add-form') {
    // Redirects to dashboard/accounts-add page if going back to accounts-load page
    return next({
      name: 'authenticated'
    })
  }

  if (authenticatedAdvisor && advisoryRedirect.indexOf(to.name) >= 0) {
    return next({
      name: `advisor-${to.name}`,
      params: to.params,
      hash: to.hash,
      query: to.query
    })
  }

  if (matched.some(authenticatedFilter)) {
    if (matched.some(advisoryFilter)) {
      if (!authenticatedAdvisor) {
        return next({
          name: 'advisory-login',
          query: {
            redirect: to.fullPath
          }
        })
      }
    } else if (!authenticated) {
      return next({
        name: 'login',
        query: {
          redirect: to.fullPath
        }
      })
    }

    return next()
  }

  if (matched.some(unauthenticatedFilter)) {
    if (authenticatedAdvisor) {
      return next({
        name: 'advisory-authenticated'
      })
    }

    if (authenticated) {
      return next({
        name: 'authenticated'
      })
    }
  }

  next()
})

export default router
